export default __webpack_public_path__ + "static/media/location.2cee64ec.svg";